export const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      work: "Work",
      clients: "Clients",
      letsTalk: "Let's Talk",
    },
    hero: {
      availability: "Available for new collaborations — 2026",
      locations: "Lisbon · São Paulo · Dubai",
      role: "[ Creative Director & Creative Consultant ]",
      tagline:
        "Over three decades turning bold ideas into powerful visual stories for **brands, sports and culture**. Founder & Creative Director of **Studio Nuts**.",
      currentFocus: "Current focus",
      currentFocusText:
        "Creative Direction · Brand Campaigns · Sports & Culture Storytelling · Visual Ideas for Digital Content.",
      seeWork: "See Work",
    },
    marquee: "Bold Ideas · Strong Visuals · Crafted with Care · ",
    about: {
      label: "[ About ]",
      headingA: "I help brands",
      headingB: "think bolder",
      headingC: "and look",
      headingD: "unmistakable",
      p1: "I'm a Brazilian creative consultant, art director and founder of **Studio Nuts** — a collective creative studio operating across Brazil, Portugal and the UAE.",
      p2: "For three decades I've been translating ambition into image, partnering with agencies and brands like **Netflix, Coca-Cola, KFC, IKEA, Heineken, Samsung, Mercedes-Benz, Volkswagen, Nestlé, Paramount** and many more — turning sharp ideas into campaigns that travel beyond borders.",
      p3: "I think like an agency, produce like a studio, and obsess over the one craft detail that makes the difference between forgettable and iconic.",
      p4: "Along the way, the work has been recognized at the world's leading creativity festivals — **4 Cannes Lions** (2 Silver, 2 Bronze), **The One Show**, **London International Awards**, **El Ojo de Iberoamérica** and a **Grand Prix in Production/VFX** at the Prémios Lusófonos. Most recently, a 2026 Bronze Lion for IKEA's \"Affordable Masterpieces\" and an ACT Responsible Cannes recognition for **\"No One Is Disposable\"** with CASA.",
      stats: [
        { value: "30+", label: "Years of craft" },
        { value: "3", label: "Markets · BR · PT · UAE" },
        { value: "60+", label: "Global brands" },
        { value: "∞", label: "Bold ideas shipped" },
      ],
    },
    services: {
      label: "[ 02 — Services ]",
      headingA: "What I bring",
      headingB: "to the room",
      intro:
        "I plug into agencies, brand teams and founders as a senior creative voice — leading, advising, or rolling sleeves up on the work itself.",
      items: [
        {
          num: "01",
          title: "Creative Direction",
          desc: "End-to-end leadership of campaigns and brand worlds — from first idea to final frame, across film, print, OOH and digital.",
          tags: ["Campaigns", "Brand Worlds", "Production"],
        },
        {
          num: "02",
          title: "Brand Strategy",
          desc: "Sharpening positioning, voice and visual systems so the story is unmistakable in any market — Brazil, Portugal, the Gulf, the world.",
          tags: ["Positioning", "Identity", "Tone of Voice"],
        },
        {
          num: "03",
          title: "Art Direction",
          desc: "Hands-on craft on photography, illustration, CGI and motion — defining the language that makes a single image impossible to ignore.",
          tags: ["Photography", "CGI", "Motion"],
        },
        {
          num: "04",
          title: "Concept & Campaigns",
          desc: "Big ideas built for fame. From pitch to production with global agencies and in-house teams, balancing risk and craft.",
          tags: ["Big Ideas", "Pitch", "Global"],
        },
        {
          num: "05",
          title: "Creative Consulting",
          desc: "Sparring partner for brand leaders and creative directors — unblocking projects, sharpening reviews, raising the work.",
          tags: ["Advisory", "Reviews", "Workshops"],
        },
        {
          num: "06",
          title: "Studio Building",
          desc: "Founder's perspective on building cross-border creative teams that think like agencies and produce like studios.",
          tags: ["Teams", "Culture", "Cross-border"],
        },
      ],
    },
    sports: {
      label: "[ 03 — Sports & Culture ]",
      headingA: "Brands, sports",
      headingB: "& culture.",
      lead:
        "I help clubs, athletes and brands create stronger stories — from campaign ideas and digital content to matchday experiences, sponsorship activations and fan engagement.",
      areasLabel: "Areas of practice",
      areas: [
        "Club identity & fan engagement",
        "Matchday campaigns",
        "Athlete storytelling",
        "Sponsor activation ideas",
        "Digital content ideas",
        "Social media storytelling",
      ],
      thinkingLabel: "[ Strategic Thinking ]",
      thinkingTitle: "Sports Marketing Thinking",
      thinkingBody:
        "Exploring how football clubs can strengthen their connection with fans, families, sponsors and local communities through content, matchday experiences, community initiatives and stronger storytelling.",
    },
    work: {
      label: "[ 04 — Selected Work ]",
      headingA: "Recent",
      headingB: "campaigns",
      headingC: "& collaborations.",
      intro:
        "A small edit of work led with Studio Nuts and partner agencies worldwide — from streaming giants and fast food legends to global consumer brands.",
      viewAll: "Visit Studio Nuts",
      roles: {
        netflix: "Creative Direction · Key Visual",
        kfc: "Concept · Art Direction",
        ikea: "Campaign · Visual Design",
        heinz: "Creative Direction · CGI",
        playdoh: "Concept · Campaign",
        apav: "Creative Direction · Social",
        dew: "Art Direction · CGI",
      },
    },
    clients: {
      label: "[ 05 — Trusted by ]",
      headingA: "Brands that bet on",
      headingB: "bold",
      intro:
        "A short list of the clients and agencies I've had the joy of shipping work with — across film, design and campaigns.",
    },
    contact: {
      label: "[ 06 — Let's Talk ]",
      headingA: "Got a",
      headingB: "bold idea",
      headingC: "?",
      headingD: "Let's create something",
      headingE: "people want to follow",
      dropLine: "Drop me a line",
      primaryCta: "Start a Project",
      linkedinCta: "Connect on LinkedIn",
      studios: "Studios",
      elsewhere: "Elsewhere",
      availability: "Availability",
      availabilityText:
        "Open for select consulting engagements and creative direction projects in **Q1 — Q2 2026**.",
    },
    footer: {
      rights: "All rights reserved.",
      designedIn: "Designed in Lisbon · São Paulo · Dubai",
    },
  },
  pt: {
    nav: {
      about: "Sobre",
      services: "Serviços",
      work: "Trabalho",
      clients: "Clientes",
      letsTalk: "Vamos Conversar",
    },
    hero: {
      availability: "Disponível para novas colaborações — 2026",
      locations: "Lisboa · São Paulo · Dubai",
      role: "[ Diretor de Criação & Consultor Criativo ]",
      tagline:
        "Mais de três décadas transformando ideias ousadas em histórias visuais marcantes para **marcas, esporte e cultura**. Fundador & Diretor de Criação do **Studio Nuts**.",
      currentFocus: "Foco atual",
      currentFocusText:
        "Direção de Criação · Campanhas de Marca · Narrativas de Esporte & Cultura · Ideias Visuais para Conteúdo Digital.",
      seeWork: "Ver Trabalho",
    },
    marquee: "Ideias Ousadas · Visuais Marcantes · Feito com Cuidado · ",
    about: {
      label: "[ Sobre ]",
      headingA: "Ajudo marcas a",
      headingB: "pensar mais ousado",
      headingC: "e parecer",
      headingD: "inconfundíveis",
      p1: "Sou um consultor criativo, diretor de arte brasileiro e fundador do **Studio Nuts** — um estúdio criativo coletivo com operações no Brasil, Portugal e Dubai.",
      p2: "Há três décadas traduzo ambição em imagem, em parceria com agências e marcas como **Netflix, Coca-Cola, KFC, IKEA, Heineken, Samsung, Mercedes-Benz, Volkswagen, Nestlé, Paramount** e muitas outras — transformando ideias afiadas em campanhas que viajam além das fronteiras.",
      p3: "Penso como agência, produzo como estúdio e me obceco pelo detalhe de craft que faz a diferença entre o esquecível e o icônico.",
      p4: "Pelo caminho, o trabalho foi reconhecido nos principais festivais de criatividade do mundo — **4 Cannes Lions** (2 Pratas, 2 Bronzes), **The One Show**, **London International Awards**, **El Ojo de Iberoamérica** e um **Grand Prix em Produção/VFX** nos Prémios Lusófonos. Mais recentemente, um Bronze em Cannes 2026 por \"Affordable Masterpieces\" para a IKEA e um reconhecimento ACT Responsible Cannes por **\"No One Is Disposable\"** com a CASA.",
      stats: [
        { value: "30+", label: "Anos de craft" },
        { value: "3", label: "Mercados · BR · PT · EAU" },
        { value: "60+", label: "Marcas globais" },
        { value: "∞", label: "Ideias ousadas entregues" },
      ],
    },
    services: {
      label: "[ 02 — Serviços ]",
      headingA: "O que trago",
      headingB: "para a mesa",
      intro:
        "Atuo com agências, times de marca e fundadores como voz criativa sênior — liderando, aconselhando ou colocando a mão na massa.",
      items: [
        {
          num: "01",
          title: "Direção de Criação",
          desc: "Liderança ponta a ponta de campanhas e universos de marca — da primeira ideia ao frame final, em film, print, OOH e digital.",
          tags: ["Campanhas", "Universos de Marca", "Produção"],
        },
        {
          num: "02",
          title: "Estratégia de Marca",
          desc: "Afiando posicionamento, voz e sistemas visuais para que a história seja inconfundível em qualquer mercado — Brasil, Portugal, Golfo, mundo.",
          tags: ["Posicionamento", "Identidade", "Tom de Voz"],
        },
        {
          num: "03",
          title: "Direção de Arte",
          desc: "Craft hands-on em fotografia, ilustração, CGI e motion — definindo a linguagem que torna uma única imagem impossível de ignorar.",
          tags: ["Fotografia", "CGI", "Motion"],
        },
        {
          num: "04",
          title: "Conceito & Campanhas",
          desc: "Grandes ideias feitas para a fama. Do pitch à produção com agências globais e times in-house, equilibrando risco e craft.",
          tags: ["Grandes Ideias", "Pitch", "Global"],
        },
        {
          num: "05",
          title: "Consultoria Criativa",
          desc: "Parceiro de sparring para líderes de marca e diretores de criação — destravando projetos, afiando reviews, elevando o trabalho.",
          tags: ["Advisory", "Reviews", "Workshops"],
        },
        {
          num: "06",
          title: "Construção de Estúdio",
          desc: "Olhar de fundador na construção de times criativos transfronteiriços que pensam como agência e produzem como estúdio.",
          tags: ["Times", "Cultura", "Transfronteiriço"],
        },
      ],
    },
    sports: {
      label: "[ 03 — Esporte & Cultura ]",
      headingA: "Marcas, esporte",
      headingB: "& cultura.",
      lead:
        "Ajudo clubes, atletas e marcas a criar histórias mais fortes — de ideias de campanha e conteúdo digital a experiências de dia de jogo, ativações de patrocínio e engajamento de fãs.",
      areasLabel: "Áreas de atuação",
      areas: [
        "Identidade do clube & engajamento de fãs",
        "Campanhas de dia de jogo",
        "Storytelling de atletas",
        "Ideias de ativação de patrocinador",
        "Ideias de conteúdo digital",
        "Storytelling em redes sociais",
      ],
      thinkingLabel: "[ Pensamento Estratégico ]",
      thinkingTitle: "Sports Marketing Thinking",
      thinkingBody:
        "Explorando como clubes de futebol podem fortalecer a conexão com torcedores, famílias, patrocinadores e comunidades locais através de conteúdo, experiências de dia de jogo, iniciativas comunitárias e uma narrativa mais forte.",
    },
    work: {
      label: "[ 04 — Trabalhos Selecionados ]",
      headingA: "Campanhas",
      headingB: "recentes",
      headingC: "& colaborações.",
      intro:
        "Uma pequena seleção de trabalhos liderados no Studio Nuts e com agências parceiras pelo mundo — de gigantes do streaming a lendas do fast food e marcas globais.",
      viewAll: "Conheça o Studio Nuts",
      roles: {
        netflix: "Direção de Criação · Key Visual",
        kfc: "Conceito · Direção de Arte",
        ikea: "Campanha · Design Visual",
        heinz: "Direção de Criação · CGI",
        playdoh: "Conceito · Campanha",
        apav: "Direção de Criação · Social",
        dew: "Direção de Arte · CGI",
      },
    },
    clients: {
      label: "[ 05 — Apoiado por ]",
      headingA: "Marcas que apostam no",
      headingB: "ousado",
      intro:
        "Uma pequena lista dos clientes e agências com quem tive o prazer de entregar trabalho — em film, design e campanhas.",
    },
    contact: {
      label: "[ 06 — Vamos Conversar ]",
      headingA: "Tem uma",
      headingB: "ideia ousada",
      headingC: "?",
      headingD: "Vamos criar algo",
      headingE: "que as pessoas queiram acompanhar",
      dropLine: "Mande uma mensagem",
      primaryCta: "Iniciar um Projeto",
      linkedinCta: "Conectar no LinkedIn",
      studios: "Estúdios",
      elsewhere: "Em outros lugares",
      availability: "Disponibilidade",
      availabilityText:
        "Aberto para engajamentos selecionados de consultoria e direção de criação em **Q1 — Q2 2026**.",
    },
    footer: {
      rights: "Todos os direitos reservados.",
      designedIn: "Concebido em Lisboa · São Paulo · Dubai",
    },
  },
};
